function add_to_cart(id, available, qty, text) {
    if (available == 'false' && parseInt(qty) <= 0) {
        document.querySelector("#productName").value = text;
        openNotifyPopup(text);
    }
    else {
        window.location.href = '/cart/add?items[][id]=' + id + '&items[][quantity]=1&return_to=/checkout';
    }
}

window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
        fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => {
                console.log('Cart cleared:', data);
                // Optional: reload page or update cart UI

            });
    }
})

function openNotifyPopup(text) {
    var popup = document.getElementById("notifyPopup");

    // Find the strong element inside the subtext paragraph
    var strongElement = popup.querySelector(".subtext p strong");
    var pElement = popup.querySelector(".subtext p");
    var heading = popup.querySelector("h2");
    var button = popup.querySelector("button");
    // Select the hidden input by ID
    let hiddenInput = document.getElementById('contact_tags');
    hiddenInput.value = text;
    if (text !== 'Email') {
        heading.textContent = "GET THE BOOK!";
        pElement.innerHTML = "<p>Enter your details below, and we'll notify you as soon as <strong>" + text + "</strong> is available.</p>";
        button.textContent = "Notify Me When Available";
    }
    else {
        heading.textContent = "BE THE FIRST TO KNOW!";
        pElement.innerHTML = "<p>Enter information below and get life-changing videos, audios, and insider secrets they dont want you to know.</p>";
        button.textContent = "Get Access";
    }
    popup.style.display = "flex";
}

function closeNotifyPopup() {
    document.getElementById("notifyPopup").style.display = "none";
}

if (window.location.href.includes('?customer_posted=true#contact_form')) {
    openNotifyPopup()
}


document.querySelector(".header__icons .button").addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelector(".process-slider-item-nav.slick-current.slick-active .button").click();
})